/*
  Options Itoris (Dynamic Product Options) en cartes — benchmark ManoMano 27/10/2026, finding #2.
  Chargé uniquement sur le modèle de fiche « produit-dpo » (blocks/_product-add-to-cart-button.liquid).

  Ce que ça fait :
  1. Chaque menu déroulant Itoris affiché devient une liste de cartes-radio (nom, ligne d'aide,
     surcoût). Le <select> d'origine reste dans la page, masqué : c'est lui qu'Itoris lit pour le
     prix, la cascade et l'ajout au panier. Une carte cochée = on écrit dans le select + 'change'.
  2. Présélection : un menu vide reçoit l'option marquée "defaut" dans le dictionnaire
     (snippets/dpo-aide.liquid), sinon celle de la déclinaison la moins chère du tableau
     comparatif (prix d'appel à l'arrivée), sinon la première option SANS surcoût. Le bouton d'achat
     marche donc au premier clic (fini « This field is required »).
  3. Rappel de la config dans tout élément [data-dpo-recap] (barre d'achat fixe).

  Pièges Itoris (cf. tableau R1, 05/08) :
  - l'app construit et reconstruit son DOM après le chargement : on ne garde AUCUNE référence,
    tout est relu à chaque passage, déclenché par un MutationObserver ;
  - la cascade est asynchrone : on ne présélectionne qu'UN menu par passage, puis on attend
    que le DOM se stabilise (sinon une branche cachée peut être remplie en parallèle).
*/
(() => {
  if (window.__dpoCartes) return;
  window.__dpoCartes = true;
  // Normalement déjà posé en ligne par le bloc d'achat (masque les menus dès leur création)
  document.documentElement.classList.add('dpo-cartes-actif');

  const DELAI = 250; // ms sans mutation avant de repasser
  const racineHtml = document.documentElement;

  /* ── Attente du chargement d'Itoris (classe posée en ligne par le bloc d'achat) ──
     8 s : message « Encore un instant… » ; 60 s : on rend la main au bouton du thème
     quoi qu'il arrive, pour ne jamais bloquer l'achat si l'app ne répond pas. */
  let pret = false;
  function marquerPret() {
    if (pret) return;
    pret = true;
    racineHtml.classList.remove('dpo-en-attente', 'dpo-attente-longue');
  }
  setTimeout(() => { if (!pret) racineHtml.classList.add('dpo-attente-longue'); }, 8000);
  setTimeout(marquerPret, 60000);

  /* ── Prix en cours de recalcul après un choix (~2 s chez Itoris) ──
     Le prix affiché est grisé avec « Calcul du prix… » jusqu'à ce que le bloc prix soit
     réécrit, avec un plafond de 4 s. */
  let finCalcul = 0;
  let suiviPrix = null;
  function debutCalcul() {
    const prix = document.getElementById('buy-price-ttc');
    if (!prix) return;
    // Message à côté du grand prix (le HT depuis le 27/10), sinon à côté du TTC
    const grand = document.querySelector('.buy-price-main .buy-price-current') || prix;
    if (!grand.parentElement.querySelector('.dpo-calcul-msg')) {
      const msg = document.createElement('span');
      msg.className = 'dpo-calcul-msg';
      msg.textContent = 'Calcul du prix…';
      grand.after(msg);
    }
    racineHtml.classList.add('dpo-prix-calcul');
    clearTimeout(finCalcul);
    finCalcul = setTimeout(arreterCalcul, 4000);
    if (suiviPrix) suiviPrix.disconnect();
    suiviPrix = new MutationObserver(() => {
      // Laisser Itoris finir sa salve d'écritures (et la présélection en cascade, qui relance
      // un 'change' ~250 ms plus tard) avant de rendre le prix : sinon l'indicateur s'éteint
      // puis le prix change encore (constaté sur le 8x3 en passant à « Amarrage étai »).
      clearTimeout(finCalcul);
      finCalcul = setTimeout(arreterCalcul, 600);
    });
    suiviPrix.observe(prix, { childList: true, characterData: true, subtree: true });
  }
  function arreterCalcul() {
    racineHtml.classList.remove('dpo-prix-calcul');
    if (suiviPrix) { suiviPrix.disconnect(); suiviPrix = null; }
  }

  // ── Dictionnaire d'aide (JSON rendu par snippets/dpo-aide.liquid) ──
  let aide = {};
  try {
    const el = document.getElementById('dpo-aide');
    if (el) aide = JSON.parse(el.textContent);
  } catch (e) {
    aide = {};
  }

  const norm = (txt) => (txt || '').replace(/\s+/g, ' ').trim().toLowerCase();

  // Entrée du dictionnaire : d'abord « champ|option », puis « option » seule
  const entree = (champ, option) => aide[`${norm(champ)}|${norm(option)}`] || aide[norm(option)] || null;

  /* Libellé Itoris → { nom, surcout }.
     Formes rencontrées sur le 8x3 :
       "Jambes de force "                                     → aucun surcoût
       "1 échelle de 2m + 2 échelles de 1m +34,80 € (HT : 29,00 €) "
       "OUI +466,80 € (HT : 389,00 €) +1.995,60€"             → surcoût 466,80 ; le dernier montant
       "NON +1.528,80€"                                          est le TOTAL, pas un surcoût
     Seul un montant suivi de « (HT » est un surcoût. */
  function lireOption(option) {
    const texte = option.textContent.replace(/\s+/g, ' ').trim();
    const surcout = texte.match(/\+\s?([\d.\s]+,\d{2})\s?€\s*\(HT/);
    const nom = texte.replace(/\s\+\s?[\d.\s]+,\d{2}\s?€.*$/, '').trim();
    return { nom, surcout: surcout ? `+${surcout[1].trim()} €` : '' };
  }

  function champsAffiches(racine) {
    return [...racine.querySelectorAll('.field[id^="dynamic_option_id_"]')].filter(
      (f) => !f.classList.contains('ihidden') && f.style.display !== 'none',
    );
  }

  function nomDuChamp(champ) {
    const label = champ.querySelector(':scope > label');
    return label ? label.textContent.trim() : '';
  }

  function choisir(select, valeur) {
    if (select.value === valeur) return;
    select.value = valeur;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Déclinaison la moins chère (demande du 27/10/2026 : la fiche s'ouvre sur le prix d'appel).
     Lue dans les boutons du tableau comparatif, rendus côté serveur avec le prix de la
     variante (data-price, centimes) et les valeurs de sa colonne (data-values « a|b|c »).
     ES45 60 m² : ES4560L à 1 968 € → « Sans » plateau + « Lisses », au lieu de « Avec »
     (1re option de la liste, 3 550,80 €). À prix égal, la 1re colonne gagne. */
  const sansAccent = (txt) => norm(txt).normalize('NFD').replace(/[̀-ͯ]/g, '');
  const valeursMoinsChere = (() => {
    let meilleur = null;
    document.querySelectorAll('[data-price][data-values]').forEach((b) => {
      const prix = parseInt(b.dataset.price, 10);
      if (!Number.isNaN(prix) && (!meilleur || prix < meilleur.prix)) meilleur = { prix, valeurs: b.dataset.values };
    });
    return meilleur ? meilleur.valeurs.split('|').map(sansAccent).filter(Boolean) : [];
  })();
  // « Lisses +1.968,00€ (avant réduction…) » → « lisses » (même découpe que assets/vc-ajout-dpo.js)
  const libelleSeul = (option) => sansAccent(option.textContent.split('+')[0]);

  // Valeur à présélectionner : "defaut" du dictionnaire, sinon l'option de la déclinaison la
  // moins chère, sinon la 1re option sans surcoût
  function valeurParDefaut(champ, select) {
    const options = [...select.options].filter((o) => o.value);
    const nomChamp = nomDuChamp(champ);
    const marquee = options.find((o) => (entree(nomChamp, lireOption(o).nom) || {}).defaut);
    if (marquee) return marquee.value;
    const moinsChere = options.find((o) => valeursMoinsChere.includes(libelleSeul(o)));
    if (moinsChere) return moinsChere.value;
    const gratuite = options.find((o) => !lireOption(o).surcout);
    return (gratuite || options[0] || {}).value || '';
  }

  function construireCartes(champ, select) {
    const nomChamp = nomDuChamp(champ);
    const options = [...select.options].filter((o) => o.value);
    const lues = options.map((o) => ({ valeur: o.value, ...lireOption(o) }));
    const unSurcout = lues.some((o) => o.surcout);

    const boite = document.createElement('div');
    boite.className = 'dpo-cartes';
    boite.setAttribute('role', 'radiogroup');
    if (nomChamp) boite.setAttribute('aria-label', nomChamp);

    lues.forEach((o) => {
      const info = entree(nomChamp, o.nom) || {};
      const carte = document.createElement('label');
      carte.className = 'dpo-carte';

      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = `dpo-carte-${select.name}`;
      radio.value = o.valeur;
      radio.checked = select.value === o.valeur;
      radio.addEventListener('change', () => choisir(select, o.valeur));

      const titre = document.createElement('span');
      titre.className = 'dpo-carte__titre';
      titre.textContent = info.titre || o.nom;
      if (info.badge) {
        const badge = document.createElement('span');
        badge.className = 'dpo-carte__badge';
        badge.textContent = info.badge;
        titre.append(' ', badge);
      }

      const prix = document.createElement('span');
      prix.className = 'dpo-carte__prix';
      prix.textContent = o.surcout || (unSurcout ? 'inclus' : '');

      carte.append(radio, titre, prix);

      if (info.aide) {
        const ligne = document.createElement('span');
        ligne.className = 'dpo-carte__aide';
        ligne.textContent = info.aide;
        carte.append(ligne);
      }
      boite.append(carte);
    });
    return boite;
  }

  function majRecap(racine) {
    const morceaux = champsAffiches(racine)
      .map((champ) => {
        const select = champ.querySelector('select.product-custom-option');
        const option = select && select.selectedOptions[0];
        if (!option || !option.value) return '';
        const nom = lireOption(option).nom;
        return (entree(nomDuChamp(champ), nom) || {}).titre || nom;
      })
      .filter(Boolean);
    // N'écrire que si ça change : chaque écriture relancerait l'observateur
    const texte = morceaux.join(' · ');
    document.querySelectorAll('[data-dpo-recap]').forEach((el) => {
      if (el.textContent !== texte) el.textContent = texte;
    });
  }

  // avecPresel = false : simple mise à jour des cartes, immédiate (aucun menu natif ne doit
  // rester sans sa carte). La présélection, elle, attend que la cascade Itoris se stabilise.
  function passe(avecPresel = true) {
    const racine = document.getElementById('itoris_dynamicproductoptions');
    if (!racine) return;
    if (racine.querySelector('.field select.product-custom-option')) marquerPret();
    let presel = false;

    racine.querySelectorAll('.field[id^="dynamic_option_id_"]').forEach((champ) => {
      const select = champ.querySelector('select.product-custom-option');
      if (!select) return;
      const affiche = !champ.classList.contains('ihidden') && champ.style.display !== 'none';
      let boite = champ.querySelector('.dpo-cartes');

      if (!affiche || select.disabled) {
        if (boite) boite.remove();
        if (champ.classList.contains('dpo-champ--cartes')) champ.classList.remove('dpo-champ--cartes');
        return;
      }

      // Un seul menu présélectionné par passage (cascade asynchrone). Jamais pendant que le
      // tableau comparatif pilote les menus (verrou posé par assets/vc-ajout-dpo.js).
      if (avecPresel && !select.value && !presel && !window.__dpoPilotage) {
        const valeur = valeurParDefaut(champ, select);
        if (valeur) {
          choisir(select, valeur);
          presel = true;
        }
      }

      // Signature : on ne reconstruit que si les options ou la sélection ont changé
      const signature = `${select.value}|${[...select.options].map((o) => o.value + o.textContent).join('¦')}`;
      if (boite && boite.dataset.signature === signature) return;

      const neuve = construireCartes(champ, select);
      neuve.dataset.signature = signature;
      if (boite) boite.replaceWith(neuve);
      else select.closest('.control').after(neuve);
      if (!champ.classList.contains('dpo-champ--cartes')) champ.classList.add('dpo-champ--cartes');
    });

    majRecap(racine);
    if (presel) planifier(); // repasser pour le menu suivant de la cascade
  }

  let minuteur = null;
  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(passe, DELAI);
  }

  let image = 0;
  function rendre() {
    cancelAnimationFrame(image);
    image = requestAnimationFrame(() => passe(false));
  }

  new MutationObserver((mutations) => {
    // Seules comptent les mutations du formulaire Itoris (ou sa création), hors nos propres
    // cartes. Perf 27/10/2026 : avant, chaque mutation de la page (avis, carrousels, pixels…)
    // relançait un passage complet.
    const utile = mutations.some((m) => {
      const cible = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      if (!cible || !cible.closest || cible.closest('.dpo-cartes')) return false;
      if (cible.closest('#itoris_dynamicproductoptions')) return true;
      return [...m.addedNodes].some(
        (n) => n.nodeType === 1 && (n.id === 'itoris_dynamicproductoptions' || !!n.querySelector('#itoris_dynamicproductoptions')),
      );
    });
    if (utile) {
      rendre();
      planifier();
    }
  }).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'disabled'],
  });

  // Choix fait (carte, présélection, tableau ou select direct) : resynchroniser les cartes et
  // signaler que le prix se recalcule
  document.addEventListener('change', (event) => {
    if (event.target.matches && event.target.matches('#itoris_dynamicproductoptions select.product-custom-option')) {
      debutCalcul();
      rendre();
      planifier();
    }
  });

  rendre();
  planifier();
})();
